<div class="row">
  <div class="col">
    <h2 class="margin-top-bottom-20px" *ngIf="user">
      <i class="fas fa-user-cog"></i>
      <a routerLink="/au/users/{{ user.userId }}">{{ user.name }}</a> on
      <a routerLink="/au/accounts/{{ accountId }}">{{ accountId }}</a>
    </h2>
  </div>
</div>

<ng-template #empty>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div *ngIf="isLoading$ | async">
            <app-loading-spinner>Loading ...</app-loading-spinner>
          </div>

          <span class="text-danger" *ngIf="isError$ | async">
            Could not fetch user details
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div
  class="row"
  *ngIf="!(isLoading$ | async) && !(isError$ | async); else empty"
>
  <ng-container *ngIf="user$ | async as user">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              <strong>Account User Type: </strong>
              <span
                *ngIf="
                  user.accountUserType === AccountUserType.Staff;
                  else customer
                "
                id="staff-user-badge"
              >
                <app-svg-icon
                  icon="a-logo"
                  height="20"
                  width="20"
                ></app-svg-icon>
                Staff User
              </span>

              <ng-template #customer>Customer</ng-template>
            </li>

            <li class="list-group-item">
              <strong>User ID:</strong> {{ user.userId }}
            </li>
            <li class="list-group-item">
              <strong>Email:</strong> {{ user.email }}
            </li>

            <li class="list-group-item" *ngIf="user.phone">
              <strong>Phone:</strong> +{{ user.countryCode }} - {{ user.phone }}
            </li>
            <li class="list-group-item account-roles">
              <strong>Account Roles: </strong>
              <ng-container *ngIf="!editRoles">
                <ng-container *ngIf="accountUserTypeRoles.length; else noRoles">
                  <div class="badges">
                    <span
                      *ngFor="let role of accountUserTypeRoles"
                      class="badge badge-success"
                      >{{ role }}</span
                    >
                  </div>
                </ng-container>
                <ng-template #noRoles>
                  <span class="no-roles">
                    No active roles for this account user
                  </span>
                </ng-template>
              </ng-container>

              <div *ngIf="editRoles">
                <app-edit-account-roles
                  [allAccountUserRoles]="roles$ | async"
                  [accountUserTypeRoles]="accountUserTypeRoles"
                  (updateAccountRoles)="onUpdateAccountRoles($event)"
                  [isUpdatingAccountRole]="isUpdatingAccountRole$ | async"
                ></app-edit-account-roles>
              </div>
              <span
                [ngbTooltip]="
                  (hasOnlyTrialDispenserRole$ | async)
                    ? 'You do not have permissions to edit roles'
                    : ''
                "
              >
                <button
                  class="btn btn-link"
                  id="edit-roles-button"
                  [disabled]="hasOnlyTrialDispenserRole$ | async"
                  (click)="editRoles = !editRoles"
                >
                  <i
                    [ngClass]="editRoles ? 'fa-times' : 'fa-pencil-alt'"
                    class="fas"
                  ></i>
                  {{ editRoles ? 'Close' : 'Edit' }}
                </button>
              </span>
            </li>
            <li class="list-group-item">
              <strong>Last login: </strong
              >{{ user.lastLogin | date: 'yyyy/MM/dd H:mm' }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div *ngIf="isDataLoaded$ | async">
  <div class="row user-options">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div *ngIf="!canTogglePermissions" class="row">
            <ngb-alert class="info-text" type="info" [dismissible]="false">
              You can only edit permissions on accounts in which you are a
              member
            </ngb-alert>
          </div>
          <app-edit-permissions
            [user]="user$ | async"
            [accountLicenses]="accountLicenses$ | async"
            [allSections]="allSections$ | async"
            (updatePermission)="updatePermission($event)"
            (updateSectionPermission)="updateSectionPermission($event)"
            [isUpdatingLicenseTool]="isUpdatingLicenseTool$ | async"
            [isUpdatingSections]="isUpdatingSections$ | async"
            [allLicenses]="allLicenses$ | async"
            [licenseTypes]="licenseTypes$ | async"
            [licensePermissions]="licensePermissions$ | async"
            [canTogglePermissions]="canTogglePermissions"
            [licensePermissionsForAccountUser]="
              licensePermissionsForAccountUser$ | async
            "
          ></app-edit-permissions>
        </div>
      </div>
    </div>
  </div>
</div>
